import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ICompany } from '../../models/company.interface';
import { CompanyService } from '../../services/company.service';
@Component({
  selector: 'app-list-companies',
  templateUrl: './list-companies.component.html',
  styleUrls: ['./list-companies.component.scss']
})
export class ListCompaniesComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() companies: ICompany[] = [];
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
      paginaSelecionada: 0,
      tamanhoPagina: 10,
      totalPaginas: 0,
      itensTotal: 0
    };


  constructor(
    private readonly companyService: CompanyService,
    private readonly toastService: ToastService,
    private readonly modalConfirmacao: ModalConfirmacaoService
  ) { }

  public toogleEmpresaStatus(companyId: string, status: boolean): void {
    const textoStatus = status ? 'desativar' : 'ativar';

    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja ${textoStatus} a empresa?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        if (status) {
          this.companyService.desativarEmpresa(companyId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        } else {
          this.companyService.ativarEmpresa(companyId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        }
      });
  }
}
